import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Image from "mui-image";
import contactIcon from "../../assets/contact-icon.svg";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import downloadIcon from "../../assets/icon-download.svg";
import DateSelectField from "./DateSelectField";
import { Link } from "react-router-dom";
import NativeSelect from "@mui/material/NativeSelect";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ContactForm = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12}>
          <Box
            className="box-container"
            sx={{
              padding: "70px 70px 73px 80px",
              backgroundColor: "rgb(243, 245, 255)",
              position: "relative",
              zIndex: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: "70px" }}>
              <Image src={contactIcon} alt="logo" width="200px" />
              <Typography
                variant="h3"
                gutterBottom
                sx={{
                  textAlign: { xs: "center", sm: "center", md: "left" },
                  fontSize: "30px",
                  lineHeight: "42px",
                  paddingLeft: "14px",
                }}
              >
                Get in touch to discuss your project, request a quote or even
                just to pick our brains.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" gutterBottom sx={{ mb: "30px" }}>
                1. Tell us about your company
              </Typography>
              <TextField
                required
                id="nameField"
                fullWidth
                type="text"
                label="Your Name"
                autoComplete="off"
                variant="outlined"
              />
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <TextField
                    required
                    id="emailField"
                    fullWidth
                    type="email"
                    label="Your Email"
                    autoComplete="off"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="phoneField"
                    fullWidth
                    type="tel"
                    label="Your Phone Number"
                    autoComplete="off"
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              <TextField
                id="urlField"
                fullWidth
                type="url"
                label="Company Name Or Website"
                autoComplete="off"
                variant="outlined"
              />
            </Box>
            <Box>
              <Typography variant="h6" gutterBottom sx={{ mb: "30px" }}>
                2. Tell us more about your project
              </Typography>
              <TextField
                required
                id="projectDesc"
                label="Describe your project briefly"
                fullWidth
                multiline
                rows={4}
              />
              <FormControl fullWidth>
                <InputLabel id="budgetInput">Estimated Budget</InputLabel>
                <Select
                  labelId="budgetId"
                  id="demo-simple-select"
                  defaultValue={10}
                  label="Estimated Budget"
                >
                  <MenuItem value={10}>50K to 100K</MenuItem>
                  <MenuItem value={20}>100K to 150K</MenuItem>
                  <MenuItem value={30}>150K to 200K</MenuItem>
                  <MenuItem value={0}>Not Sure</MenuItem>
                </Select>
              </FormControl>

              <Grid
                container
                sx={{
                  border: "1px dashed rgba(0, 0, 0, 0.2)",
                  padding: "39px 24px 11px",
                  borderRadius: "6px",
                }}
              >
                <Grid item xs={12} md={10}>
                  <InputLabel id="budgetInput">
                    <img
                      src={downloadIcon}
                      width={20}
                      style={{ marginRight: "9px" }}
                      alt="download-icon"
                    />
                    Drag images or browse to upload (optional)
                  </InputLabel>
                </Grid>
                <Grid item xs={12} md={2}>
                  <FormControl fullWidth>
                    <TextField
                      id="getFile"
                      name="upload-photo"
                      type="file"
                      style={{ display: "none" }}
                    />
                    <label htmlFor="getFile" className="buttonUploda">
                      UPLOAD
                    </label>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ mb: "30px", mt: "30px" }}
              >
                3. Where did you hear about us?
              </Typography>
              <TextField
                required
                id="projectDesc"
                label="How did you hear about us?"
                fullWidth
                multiline
                rows={4}
              />
            </Box>
            <Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ mb: "30px", fontWeight: "light" }}
                >
                  Select a day
                </Typography>
                <Typography
                  variant="h6"
                  gutterBottom
                  className="meetingBefore"
                  sx={{ mb: "30px", position: "relative" }}
                >
                  30 Min Meeting
                </Typography>
              </Box>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ mb: "30px", mt: "30px" }}
              >
                4. Schedule a call with our tech expert. Get a detailed tech
                consultation for free!
              </Typography>
              {/* import date select field component */}
              <DateSelectField />
              <Box sx={{ display: "flex" }}>
                <Typography variant="h6" sx={{ mt: "30px" }}>
                  Timezone -
                  <FormControl sx={{ m: 1, top: "-11px" }}>
                    <NativeSelect
                      disableUnderline={true}
                      defaultValue="EST"
                      sx={{ fontSize: "16px" }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="EST">EST</option>
                      <option value="MST">MST</option>
                      <option value="IST">IST</option>
                    </NativeSelect>
                  </FormControl>
                </Typography>
                <Typography variant="h6" sx={{ mt: "30px" }}>
                  Schedule Meeting-
                  <FormControl sx={{ m: 1, top: "-11px" }}>
                    <NativeSelect
                      disableUnderline={true}
                      defaultValue="6"
                      sx={{ fontSize: "16px", marginBottom: "0px!important" }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="6">6am-7am</option>
                      <option value="7">7am-8am</option>
                      <option value="8">8am-9am</option>
                      <option value="9">9am-10am</option>
                    </NativeSelect>
                  </FormControl>
                </Typography>
              </Box>
              <Box>
                <Link
                  to="/submit"
                  style={{ textDecoration: "none", paddingTop: "9px" }}
                >
                  <div className="button_slide slide_down">SUBMIT</div>
                </Link>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ContactForm;
